import { fetchContentfulExport } from '../../api/index';
import {
  EXPORT_CONTENTFUL_STARTED,
  EXPORT_CONTENTFUL_SUCCEEDED,
  EXPORT_CONTENTFUL_FAILED,
} from '../action-types/exportContentfulActionTypes';
import { logDownloadAction } from '../../actions/usagelogging';
import { EXPORT_CONTENTFUL_DOWNLOAD } from '../../utils/google-analytics-labels';

export const exportContentfulStarted = () => ({
  type: EXPORT_CONTENTFUL_STARTED,
});

export const exportContentfulSucceeded = (contentfulData) => ({
  type: EXPORT_CONTENTFUL_SUCCEEDED,
  contentfulData: contentfulData,
});

export const exportContentfulFailed = (err) => ({
  type: EXPORT_CONTENTFUL_FAILED,
  error: err,
});

const exportContentfulCreators = {
  fetchContentfulExportAction: (user) => (dispatch) => {
    dispatch(exportContentfulStarted());
    fetchContentfulExport(user)
      .then((res) => {
        if (res.data) {
          let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel',
          });
          let url = window.URL.createObjectURL(blob);
          const filename = 'contentfulexport.xls';
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            url = window.URL.createObjectURL(blob);
          }

          const link = document.createElement('a');
          link.href = url;

          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.outerHTML = '';
          dispatch(exportContentfulSucceeded(res.data));
        } else {
          dispatch(exportContentfulFailed('Unable to export contentful data'));
        }
      })
      .catch((err) => {
        dispatch(exportContentfulFailed(err));
      });

    dispatch(logDownloadAction(user, EXPORT_CONTENTFUL_DOWNLOAD));
  },
};

export default exportContentfulCreators;
